import React from "react"
import Helmet from 'react-helmet'
import { graphql } from "gatsby"
import parse from 'html-react-parser'
import { cleanPtags, phoneNumberUrl, scrollDiv, stripTags } from '../Helpers'
import Layout from "../components/layout"
import Seo from "../components/seo"

import Arrow from "../components/Arrow"
import FormJobApplication from "../components/FormJobApplication"

import IconImmediately from "../components/icons/IconImmediately"
import IconWorkModel from "../components/icons/IconWorkModel"
import IconLocation from "../components/icons/IconLocation"

import IconMapMarker from "../components/icons/IconMapMarker"
import IconClose from "../components/icons/IconClose"
import IconJobTasks from "../components/icons/IconJobTasks"
import IconJobAbilities from "../components/icons/IconJobAbilities"
import IconJobOffer from "../components/icons/IconJobOffer"

export default function Post({ data }) {

    const post = data.allWpJob.nodes[0]
    const acf = post.jobACF
    const contact = acf.contactPerson.autoren

    let metaTitle = false
    let metaDescription = false
    let ogImage = false

    if(post.seoMetaData) {
        metaTitle = post.seoMetaData.seoMetaTitle ? post.seoMetaData.seoMetaTitle : false
        metaDescription = post.seoMetaData.seoMetaDescription ? post.seoMetaData.seoMetaDescription : false
        ogImage = post.seoMetaData.seoMetaOgImage ? post.seoMetaData.seoMetaOgImage : false
    }

    const [isContactFormExpanded, setContactFormExpanded] = React.useState(false)
    const formJobApplication = React.createRef()

    var structuredData = {
        '@context': 'https://schema.org/',
        '@type': 'JobPosting',
        'title': post.title,
        'description': stripTags(acf.beschreibung),
        'hiringOrganization': {
            '@type': 'Organization',
            'name': 'Rekord Fenster ' + acf.location
        },
        'datePosted': post.date,
        'validThrough': '',
        'jobLocation': {
            '@type': 'Place',
            'address': {
                '@type': 'PostalAddress',
                'streetAddress': acf.locationStreet,
                'addressLocality': acf.locationCity,
                'postalCode': acf.locationZip,
                'addressCountry': 'AT'
            }
        }
    }

    return (
        <Layout contact="false">
            <Seo
                metaTitle={metaTitle}
                metaDescription={metaDescription}
                uri={post.uri}
                ogImage={ogImage}
            />
            <Helmet>
                <body className="font-inter text-black scroll-smooth job-single" />
                <meta name="robots" content="noindex" />
            </Helmet>
            <section className="relative w-full h-40-screen hero">
                <div className="w-full h-full">
                    {acf.cover ? <img className="w-full h-full object-cover object-top" src={acf.cover.sourceUrl} alt={acf.cover.altText} sizes="(max-width: 2560px) 100vw, 2560px" /> : ''}
                </div>
            </section>
            <section className="max-w-5xl px-4 mx-auto py-16 lg:py-36">
                <h1 className="text-4xl lg:text-5xl">{post.title}</h1>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-12">
                    <div>
                        <span className="uppercase font-light text-lg">Für den Rekord-Standort:</span>
                        <div className="flex mt-4">
                            <IconMapMarker w="50" h="50" />
                            <div className="font-light text-lg ml-4">{parse(acf.locationAddress)}</div>
                        </div>
                        <div className="mt-8">
                            {acf.locationImage ? <img className="w-full h-auto" src={acf.locationImage.sourceUrl} alt={acf.locationImage.altText} sizes="(max-width: 800px) 100vw, 800px" /> : ''}
                        </div>
                    </div>
                    <div>{parse(acf.beschreibung)}</div>
                </div>
            </section>
            <section className="w-full bg-rekord-lorange">
                <div className="container mx-auto py-12 lg:py-20">
                    <div id="jobAdvantagesList" className="overflow-x-auto lg:overflow-x-visible overflow-y-hidden scroll-smooth whitespace-nowrap lg:whitespace-normal lg:grid lg:grid-cols-3 lg:gap-6">
                        <div className="inline-block w-full">
                            <div className="flex flex-col items-center justify-between whitespace-normal">
                                <IconImmediately w="60" h="60" />
                                <div className="mt-4 text-center text-2xl font-light lg:w-2/3">{parse(cleanPtags(acf.benefit1))}</div>
                            </div>
                        </div>
                        <div className="inline-block w-full">
                            <div className="flex flex-col items-center justify-between whitespace-normal">
                                <IconWorkModel w="60" h="60" />
                                <div className="mt-4 text-center text-2xl font-light lg:w-2/3">{parse(cleanPtags(acf.benefit2))}</div>
                            </div>
                        </div>
                        <div className="inline-block w-full">
                            <div className="flex flex-col items-center justify-between whitespace-normal">
                                <IconLocation w="40" h="50" />
                                <div className="mt-4 text-center text-2xl font-light lg:w-2/3">{parse(cleanPtags(acf.benefit3))}</div>
                            </div>
                        </div>
                    </div>
                    <div className="flex lg:hidden justify-end pt-6">
                        <button onClick={() => { scrollDiv('jobAdvantagesList', 'left') }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="32.621" height="24.543" viewBox="0 0 32.621 24.543">
                                <g id="Pfeil" transform="translate(32.621)">
                                    <path id="Stroke_10" data-name="Stroke 10" d="M0,.5H-29.378" transform="translate(0 11.771)" fill="none" stroke="#000" strokeMiterlimit="10" strokeWidth="3" />
                                    <path id="Fill_12" data-name="Fill 12" d="M-2.047,24.543,0,22.344-10.838,12.273,0,2.2-2.047,0l-13.2,12.273Z" transform="translate(-17.378)" />
                                </g>
                            </svg>
                        </button>
                        <button className="ml-4" onClick={() => { scrollDiv('jobAdvantagesList', 'right') }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="32.621" height="24.543" viewBox="0 0 32.621 24.543">
                                <g id="Pfeil" transform="translate(0)">
                                    <path id="Stroke_10" data-name="Stroke 10" d="M0,.5H29.378" transform="translate(0 11.771)" fill="none" stroke="#000" strokeMiterlimit="10" strokeWidth="3" />
                                    <path id="Fill_12" data-name="Fill 12" d="M2.047,24.543,0,22.344,10.838,12.273,0,2.2,2.047,0l13.2,12.273Z" transform="translate(17.378)" />
                                </g>
                            </svg>
                        </button>
                    </div>
                </div>
            </section>
            {acf.media ?
                <section className="max-w-7xl px-4 mx-auto py-16 lg:py-36">
                    <div className="container-video">
                        <iframe src={acf.media} title={'Rekord Fenster | Video: ' + post.title} />
                    </div>
                </section>
                : ''}
            <section className="w-full bg-rekord-lgray">
                <div className="container mx-auto py-16 lg:py-24 grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-12">
                    <div className="text-lg font-light">
                        <IconJobTasks w="80" h="100" />
                        <h3 className="mt-8 mb-8 text-3xl">
                            Deine Aufgaben
                        </h3>
                        {parse(acf.yourJob)}
                    </div>
                    <div className="text-lg font-light">
                        <IconJobAbilities w="80" h="100" />
                        <h3 className="mt-8 mb-8 text-3xl">
                            Deine Qualifikationen
                        </h3>
                        {parse(acf.yourQualifications)}
                    </div>
                    <div className="text-lg font-light">
                        <IconJobOffer w="100" h="100" />
                        <h3 className="mt-8 mb-8 text-3xl">
                            Wir bieten dir
                        </h3>
                        {parse(acf.whatWeOffer)}
                    </div>
                </div>
            </section>
            {contact ?
                <>
                    <section className="max-w-6xl mx-auto px-4 py-16 lg:py-24 grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-36">
                        <div className="text-lg font-light flex flex-col items-center">
                            <h3 className="text-center mb-12">Servus, ich kümmere mich um deine Bewerbung!</h3>
                            {contact.authorImage ?
                                <div className="px-24 lg:px-0">
                                    <img className="rounded-full w-60 h-60 object-cover object-top" src={contact.authorImage.sourceUrl} alt={contact.authorImage.altText} sizes="(max-width: 250px) 100vw, 250px" />
                                </div>
                                :
                                <></>
                            }
                            <p className="text-lg text-center mt-12 font-normal">
                                <strong className="text-xl">{contact.authorName}</strong><br />
                                {contact.authorPosition} für<br />
                                {contact.authorLocation}
                            </p>
                            <p className="text-lg font-light text-center mt-4">
                                {parse(contact.authorAddress)}
                            </p>
                            <p className="text-base text-center mt-4">
                                <a href={phoneNumberUrl(contact.authorPhone)} title={'Jetzt ' + contact.authorName + ' anrufen'} className="text-rekord-orange no-underline font-light">{contact.authorPhone}</a><br />
                                <a href={'mailto:' + contact.authorEmail} title={'Jetzt ' + contact.authorName + ' per Email kontaktieren'} className="text-rekord-orange no-underline font-light">{contact.authorEmail}</a>
                            </p>
                        </div>
                        <div className="text-lg font-light">
                            <h3>Jetzt direkt bewerben!</h3>
                            <p className="mt-6 mb-12">Bitte trag hier deine Kontaktdaten ein:</p>
                            <FormJobApplication formId="specificForm" type={'Bewerbung: ' + post.title} recipient={contact.authorEmail} locationName={'Rekord Fenster ' + acf.location} />
                        </div>
                    </section>
                    <section className="bg-rekord-lgreen mb-6">
                        <div className="container mx-auto py-16 lg:py-24 flex flex-col lg:flex-row lg:items-end">
                            <div className="lg:mr-24">
                                <h3 className="uppercase mt-32">
                                    War nichts dabei?<br />
                                    <span className="text-rekord-orange">Bewirb dich initiativ</span>
                                </h3>
                            </div>
                            <div className="mt-12 lg:mt-0 lg:mr-24 flex flex-row">
                                <button className="font-bold text-lg text-rekord-orange no-underline ml-8" onClick={() => { setContactFormExpanded(!isContactFormExpanded); formJobApplication.current.scrollIntoView({ behavior: 'smooth', block: 'start' }) }}><Arrow color="#FF8400" /> Initiativ bewerben</button>
                            </div>
                        </div>
                    </section>
                    <section ref={formJobApplication} className={isContactFormExpanded ? "bg-rekord-lgreen left-0 top-0 h-full w-full opacity-100 overflow-visible relative" : "h-0 w-0 opacity-0 overflow-hidden"}>
                        <button onClick={() => { setContactFormExpanded(!isContactFormExpanded) }} className="absolute right-12 top-12"><IconClose w="40" h="40" /><span className="hidden">Schließen</span></button>
                        <div className="w-full mx-auto h-full flex flex-col justify-center items-center">
                            <div className="container max-w-lg pb-24">
                                <h3 className="w-1/3 text-left mt-16 mb-12 text-2xl font-light">Initiativ Bewerbung</h3>
                                <div>
                                    <FormJobApplication formId="initiativForm" type="Initiativ Bewerbung" locationName={'Rekord Fenster ' + acf.location} />
                                </div>
                            </div>
                        </div>
                    </section>
                </>
            : <></>}
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
            />
        </Layout>
    )
}

export const query = graphql`
    query($slug: String!) {
        allWpJob(filter: { slug: { eq: $slug } }) {
            nodes {
                date(formatString: "DD-MM-YYYY")
                uri
               seoMetaData {
                   seoMetaTitle
                   seoMetaDescription
                   seoMetaOgImage {
                   height
                   width
                   sourceUrl
                   mimeType
                   }
               }
                jobACF {
                    cover {
                        altText
                        sourceUrl
                    }
                    locationImage {
                        altText
                        sourceUrl
                    }
                    location
                    locationAddress
                    locationStreet
                    locationZip
                    locationCity
                    beschreibung
                    benefit1
                    benefit2
                    benefit3
                    media
                    yourJob
                    yourQualifications
                    whatWeOffer
                    contactPerson {
                        ... on WpAutor {
                            id
                            autoren {
                                authorImage {
                                    altText
                                    sourceUrl
                                }
                                authorName
                                authorPosition
                                authorLocation
                                authorAddress
                                authorEmail
                                authorPhone
                            }
                        }
                    }
                }
                title
            }
        }
    }
`
